import React from 'react';
import get from 'lodash/get';

import Table from 'components/shared/table';

const TableLoadingCell = ({ contentClassName, size, width, roleTag }) => (
  <Table.Body.Cell contentClassName={contentClassName} size={size}>
    <div
      className="Placeholder-text Loading-cells-placeholder"
      style={{ width: `${width}%`, margin: '4px 0' }}
    />
    {roleTag && (
      <div
        className="Placeholder-text"
        style={{ width: get(roleTag, 'width', '25%'), margin: '4px 0px' }}
      />
    )}
  </Table.Body.Cell>
);

export default TableLoadingCell;
